import styled from "styled-components";
import { colors } from "../system";

export const NumberCircle = styled.div`
  display: flex;
  margin: 22px 5px 22px 0;
  background-color: ${colors.lightGrey};
  border-radius: 50%;
  min-width: 36px;
  min-height: 36px;
  justify-content: center;
  align-items: center;
`;
